import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {User} from '../types';
import {UserStatusBadge} from '../profile/UserStatusBadge';

export const columns = [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: User) => <NavLink
            to={`/users/${item.id}`}>{[item.givenName, item.familyName].join(' ')}</NavLink>,
    },
    {
        title: I18n.get('Email'),
        width: '1fr',
        render: (item: User) => item.email,
    },
    {
        title: I18n.get('Account'),
        width: '1fr',
        render: (item: User) => <NavLink to={`/accounts/${item.accountId}`}>{item.accountId}</NavLink>,
    },
    {
        title: I18n.get('User Status'),
        width: '1fr',
        render: (item: User) => <UserStatusBadge record={item}/>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: User) => formatTimestamp(item.created as string),
    },
    {
        title: I18n.get('Last Updated'),
        width: '1fr',
        render: (item: User) => formatTimestamp(item.updated as string),
    },
];
